window.AOS = require('aos')

new AOS.init({
    duration: 1000
});
